import axiosInstance from "@/api/axios-instance";

export async function getPaymentPages({
  page,
  status,
  region,
  search,
  limit,
}: {
  page: number;
  status?: string;
  region?: string;
  search?: string;
  limit?: number;
}) {
  const params: Record<string, any> = { page };
  if (limit) params.limit = limit;
  if (status && status !== "ALL") params.status = status;
  if (region && region !== "ALL") params.region = region;
  if (search?.trim()) params.search = search.trim();

  const response = await axiosInstance.get("/payment-pages", { params });

  if (!response.status.toString().startsWith("2")) {
    throw new Error("payment pages are not loaded");
  }

  const { paymentPages, nextPage, lastPage, page: currentPage, total } =
    response.data;
  return { paymentPages, nextPage, lastPage, currentPage, total };
}
